export const ProjectData = [
  {
    id: 1,
    title: "Realy (Room Booking App)",
    about:
      " The Project would allow users to book rooms at a hotel or other accommodation. It would be built using MongoDB to store information about rooms, reservations, and users. Express.js would be used as the server-side framework, handling requests and responses from the client.    The front-end of the project would be built using React, Users would be able to search for available rooms based on dates and other criteria, view room details, and book rooms by filling out a reservation form. Build an admin Dashboard where Functionality allows to create and delete, Rooms and Hotels to upload pictures and show all states and activities of the Realy application and how many user rooms and hotels.",
    tags: ["React.js", "NodeJs", "MongoDB", "Express", "API", "CSS"],
    demo: "qwerqwer",
    github: "https://github.com/prince-111/Realy",
    image:
      "https://github.com/prince-111/Realy/assets/88477312/71f9aaac-971b-473b-ad5e-995b64981af8",
  },
  {
    id: 2,
    title: "NoteBook (CRUD On MERN)",
    about: "Developed a fully functional web application using the MERN stack. Implemented secure user authentication and password hashing using bcrypt to store passwords in MongoDB. Created RESTful APIs using Express.js and Node.js to handle user requests and perform CRUD operations. Implemented user authentication using JSON Web Tokens (JWT) for secure access to the application.   Created a responsive user interface using React components, allowing users to create, edit, and manage their notes.    ",
    tags: ["React.js", "NodeJs", "MongoDB", "Express", "API", "Bootstrap"],
    demo: "qwerqwer",
    github: "https://github.com/prince-111/NoteBook",
    image:
      "https://github.com/prince-111/NoteBook/assets/88477312/b33dd0a2-82ca-4ee7-9ca6-e544a4975f5c",
  },
  {
    id: 3,
    title: "NewsViews (API Fetch)",
    about:"Developed a dynamic web application using React.js to fetch and display news data from a news API. Implemented infinite scrolling functionality to load and display news articles as the user scrolls down the page, providing a seamless browsing experience and efficient data loading. Integrated and consumed a news API to fetch real-time news articles, demonstrating proficiency in API integration and data manipulation. Utilized React Hooks for state management and side effects.",
    tags: ["React.js","Hook", "Infinte Scrolling", "API", "Boostrap"],
    demo: "qwerqwer",
    github: "https://github.com/prince-111/NewsViews",
    image:
      "https://github.com/prince-111/NewsViews/assets/88477312/7265ed26-32be-40e8-8a5d-ac0eab5ae082",
  },
  {
    id: 4,
    title: "RazorPay-Clone-Web-UI",
    about:"This Project aims to replicate the user interface of the Razorpay website, providing a similar look and feel for users. The project was challenging because I had to learn how to use Vite, Tailwind CSS, and React.js. However, I was able to overcome these challenges by reading documentation, watching tutorials, and asking for help from online communities.  In the future, I plan to deploy this project to production and add new features, such as a shipping calculator and a customer support page.",
    tags: ["React.js", "Redux", "Tailwind CSS","Vite","HTML"],
    demo: "qwerqwer",
    github: "https://github.com/prince-111/RazorPay-Clone-Web-UI",
    image:
      "https://github.com/prince-111/RazorPay-Clone-Web-UI/assets/88477312/b0c897ae-95e4-443f-9e98-413ccea94605",
  },
  {
    id: 5,
    title: "DisCode (Communication)",
    about:
      " A connection is opened between the client and the server so that the client can send and receive data. This allows real-time communication using TCP sockets. This is made possible by Socket.io. The client connects to the server through a socket. Once connections is successful, client and server can emit and listen to events. Currently, I am using an array called ‘users’ to store the information of all the new users.As soon as a new user enters a chat room an object is created that contains all the information such as username, id and room. This object is pushed into the ‘users’ array. The repository contains details information about the code.",
    tags: ["Socket.io", "React.js", "JavaScript", "HTML", "CSS"],
    demo: "qwerqwer",
    github: "https://github.com/prince-111/DisCode",
    image:
      "https://user-images.githubusercontent.com/88477312/204710395-82a9d61d-bc26-4bda-b06f-aabcdd9974c7.png",
  },
  {
    id: 6,
    title: "UsabilityHub",
    about:
    "Developed a responsive Usability Hub website from scratch using HTML, CSS, and JavaScript, and it's also Responsive for Multiple Devices",
    tags: ["HTML", "CSS", "JavaScript", "Responsive"],
    demo: "qwerqwer",
    github: "https://github.com/prince-111/UsabilityHub",
    image:
    "https://user-images.githubusercontent.com/88477312/218045618-be62fdd9-b514-4ed0-ab05-10d353c3f067.png",
  },
  {
    id: 7,
    title: "Amazon.com",
    about:
      " Design a responsive layout that mimics the overall structure of Amazon's website. This includes a header with a logo, navigation menu, search bar, and user account options. Use a grid system or flexbox to organize the main content area, sidebar, and footer.",
    tags: ["HTML", "CSS"],
    demo: "qwerqwer",
    github: "https://github.com/prince-111/Amazon.com-Clone-UI",
    image:
      "https://github.com/prince-111/Amazon.com-Clone-UI/assets/88477312/fa7e29ed-4929-4427-90a3-b6618a1892b6",
  },
  // {
  //   id: 8,
  //   title: "DEMO (Projects)",
  //   about:
  //     " The Project would allow users to book rooms at a hotel or other accommodation. It would be built using MongoDB to store information about rooms, reservations, and users. Express.js would be used as the server-side framework, handling requests and responses from the client.    The front-end of the project would be built using React, Users would be able to search for available rooms based on dates and other criteria, view room details, and book rooms by filling out a reservation form. Build an admin Dashboard where Functionality allows to create and delete, Rooms and Hotels to upload pictures and show all states and activities of the Realy application and how many user rooms and hotels.",
  //   tags: ["React.js", "Redux", "Tailwind CSS"],
  //   demo: "qwerqwer",
  //   github: "https://github.com/prince-111/Realy",
  //   image:
  //     "https://img.freepik.com/free-vector/business-team-discussing-ideas-startup_74855-4380.jpg?w=826&t=st=1688114123~exp=1688114723~hmac=6eafb42bfa30c0fab3864adfffada0ded1c2cbc61880384295b8fca9891090ac",
  // },
];
